import React from 'react'
import CreateAssetQrCode from '../../components/assetqrcodecomponents/CreateAssetQrCode'

function AssetQrCodeList() {
  return (
    <div> <CreateAssetQrCode /> </div>
  )
}

export default AssetQrCodeList